__turbopack_context__.v({
  "disabledLabel": "RadioButton-module__IHvRXW__disabledLabel",
  "label": "RadioButton-module__IHvRXW__label",
  "radio": "RadioButton-module__IHvRXW__radio",
  "radioCircle": "RadioButton-module__IHvRXW__radioCircle",
  "radioContainer": "RadioButton-module__IHvRXW__radioContainer",
  "radioWrapper": "RadioButton-module__IHvRXW__radioWrapper",
});
